<template>
    <svg width="41" height="41" viewBox="0 0 41 41" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <rect width="41" height="41" rx="12"/>
            <path d="M20.003 13.906c.083-.188.156-.379.25-.561a5.926 5.926 0 0 1 4.46-3.234 6.268 6.268 0 0 1 5.047 1.194 5.458 5.458 0 0 1 2.151 3.424c.11.619.121 1.25.033 1.873a10.216 10.216 0 0 1-2.046 4.748 19.587 19.587 0 0 1-2.43 2.752c-.753.708-1.53 1.4-2.32 2.069-1.1.935-2.306 1.747-3.472 2.606-.553.407-1.109.811-1.673 1.223l-.739-.537c-.909-.664-1.816-1.331-2.728-1.992a35.612 35.612 0 0 1-4.131-3.492 19.487 19.487 0 0 1-2.891-3.506 9.784 9.784 0 0 1-1.39-3.408 5.783 5.783 0 0 1 .277-3.4 5.859 5.859 0 0 1 3.521-3.275 6.55 6.55 0 0 1 6.109.894 5.594 5.594 0 0 1 1.946 2.606c.006.006.016.009.026.016z" fill="#F796A1" fill-rule="nonzero"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconFavoriteActive',
};
</script>
